import React, { memo, useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Clock from "../components/Clock";
import Footer from "../components/footer";
import ArtViewTracker from "../../Common/ArtViewTracker";
import { createGlobalStyle } from "styled-components";
import * as selectors from "../../store/selectors";
import { DAppClient, NetworkType } from "@airgap/beacon-sdk";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import CustomToastContainer from "../../Common/CustomToastContainer";
import api from "../../core/api";
import moment from "moment";
import { createHistory } from "../../Common/createHistory";
import { useParams } from "react-router-dom";
import axios from "axios";
import BuyTezModal from "../menu/BuyNFT";
import CryptoJS from "crypto-js";
import io from "socket.io-client";
import { logger } from "ethers";
const socket = io(process.env.REACT_APP_SOCKET_SERVER_URL, {
  transports: ["websocket"],
});
const tezos = new TezosToolkit(process.env.REACT_APP_RPC_URL); // or use a custom RPC endpoint

const wallet = new BeaconWallet({
  name: "ArtCollect",
  preferredNetwork: NetworkType.GHOSTNET, // or GHOSTNET
});

tezos.setWalletProvider(wallet);
const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #FAF6F1;
    border-bottom: solid 1px #ccc !important;
  }
  .mr40{
    margin-right: 40px;
  }
  .mr15{
    margin-right: 15px;
  }
  .btn2{
    background: #f6f6f6;
    color: #333 !important;
  }
`;
const generateAvatarurl = process.env.REACT_APP_GENERATE_AVATAR_URL;
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const tzktendpoint = process.env.REACT_APP_TZKT_API_ENDPOINT;
const ghostnet = process.env.REACT_APP_TZKT_GHOSTNET_API_ENDPOINT;
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
const ItemDetailRedux = () => {
  const { nftId } = useParams();
  const [render, setRender] = useState(0);
  const mainBtnRef0 = React.useRef(null);
  const mainBtnRef = React.useRef(null);
  const mainBtnRef1 = React.useRef(null);
  const toastRef = useRef();
  const [nft, setNft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [fileSize, setFileSize] = useState(null);
  const [error, setError] = useState(null);
  const [openMenu0, setOpenMenu0] = React.useState(false); // Details
  const [openMenu, setOpenMenu] = React.useState(false); // Offers
  const [openMenu1, setOpenMenu1] = React.useState(false);
  const [userAddress, setUserAddress] = useState();
  const [showBidModal, setShowBidModal] = useState(false);
  const [showMakeModal, setshowMakeModal] = useState(false);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [bidAmount, setBidAmount] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [creatorSales, setCreatorSales] = useState(0);
  const [bidderOwner, setbidderOwner] = useState("");
  const [bidError, setBidError] = useState(false);
  const [bids, setBids] = useState([]);
  const [amount, setAmount] = useState("");
  const [showCryptoList, setShowCryptoList] = useState(false);
  const [crypto, setCrypto] = useState({ name: "Tezos", symbol: "ꜩ" });
  const cryptoOptions = [
    { name: "Tezos", symbol: "ꜩ" },
    { name: "Bitcoin", symbol: "BTC" },
    { name: "Ethereum", symbol: "ETH" },
  ];

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleCryptoSelection = (option) => {
    setCrypto(option);
    setShowCryptoList(false);
  };

  const handleBtnClick0 = () => {
    setOpenMenu0(true);
    setOpenMenu(false);
    setOpenMenu1(false);
    mainBtnRef0.current?.classList.add("active");
    mainBtnRef?.current?.classList.remove("active");
    mainBtnRef1.current?.classList.remove("active");
  };

  const handleBtnClick = () => {
    setOpenMenu(true);
    setOpenMenu1(false);
    setOpenMenu0(false);
    mainBtnRef?.current?.classList.add("active");
    mainBtnRef1.current?.classList.remove("active");
    mainBtnRef0.current?.classList.remove("active");
  };

  const handleBtnClick1 = () => {
    setOpenMenu1(true);
    setOpenMenu(false);
    setOpenMenu0(false);
    mainBtnRef1.current?.classList.add("active");
    mainBtnRef?.current?.classList.remove("active");
    mainBtnRef0.current?.classList.remove("active");
  };
  const generateAvatar = (walletAddress) => {
    return `${generateAvatarurl}/${walletAddress}.png?size=200x200`;
  };

  const toTez = (mutez) => mutez / 1000000;
  const shortenAddress = (address) => {
    if (!address) return "";
    return address.slice(0, 5) + "..." + address.slice(-4);
  };
  const fetchUsernames = async (bids) => {
    const updatedBids = await Promise.all(
      bids.map(async (bid) => {
        try {
          const profileRes = await axios.get(
            `${ghostnet}/v1/accounts/${bid.bidder}`
          );
          return { ...bid, username: profileRes.data.alias || bid.bidder };
        } catch {
          return { ...bid, username: bid.bidder }; // Fallback to address if no alias found
        }
      })
    );
    return updatedBids;
  };
  const handleBidChange = (e, currentBid) => {
    const value = e.target.value;
    setBidAmount(value);

    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue) && parsedValue > currentBid) {
      setBidError(false);
    } else {
      setBidError(true);
    }
  };

  const dispatch = useDispatch();
  const nftDetailState = useSelector(selectors.nftDetailState);
  //   const nft = nftDetailState.data ? nftDetailState.data : [];

  const [openCheckout, setOpenCheckout] = React.useState(false);
  const [openCheckoutbid, setOpenCheckoutbid] = React.useState(false);

  useEffect(() => {
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      setUserAddress(storedAddress);
      axios
        .get(`${domainpath}/api/creator-sales/wallet/${storedAddress}`)
        .then((res) => {
          setCreatorSales(res.data.salesCount);
        })
        .catch((err) => console.error("Error fetching sales:", err));
    }
  }, []);

  const fetchUsernamesFromHistory = async (history) => {
    const enriched = await Promise.all(
      history.map(async (entry) => {
        try {
          const address = entry?.author?.address || entry.author;
          const profileRes = await axios.get(
            `${ghostnet}/v1/accounts/${address}`
          );
          return {
            ...entry,
            author: {
              ...entry.author,
              username: profileRes.data.alias || address,
            },
          };
        } catch {
          return {
            ...entry,
            author: {
              ...entry.author,
              username: entry?.author?.address || entry.author,
            },
          };
        }
      })
    );
    return enriched;
  };
  const fetchBidHistory = async (nft_id) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${domainpath}/api/bid/offers/${nft_id}`
      );
      if (response.data.success) {
        setbidderOwner(response.data.owner);
        setBids(response.data.offers); // Contains enriched data: username, profileImage
      } else {
        setError("Failed to load bids.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const convertIPFSToHTTP = (url) => {
      if (!url) return "";
      return url.startsWith("ipfs://")
        ? url.replace("ipfs://", "https://ipfs.io/ipfs/")
        : url;
    };
    const fetchMimeType = async (url, nftdata) => {
      try {
        const res = await fetch(url, { method: "HEAD" });
        return res.headers.get("Content-Type");
      } catch (err) {
        ////console.error("Error fetching MIME type:", err);
        return nftdata.blockchainData.mime_type;
      }
    };
    const fetchFileSize = async (url) => {
      try {
        const res = await fetch(url, { method: "HEAD" });
        const size = res.headers.get("content-length");
        if (size) {
          setFileSize((size / (1024 * 1024)).toFixed(2)); // in MB
        } else {
          ////console.error("Content-Length header not found");
        }
      } catch (err) {
        ////console.error("Error fetching file size:", err);
      }
    };

    const fetchNFTDetail = async (nftId) => {
      try {
        setLoading(true);
        const response = await axios.get(`${domainpath}/api/art/${nftId}`);
        const nftData = response.data;
        // console.log(nftData, "nftData");
        if (nftData.blockchainData.open_to_auction === true) {
          setbidderOwner(nftData.blockchainData.owner);
          const bidsWithUsernames = await fetchUsernames(nftData.bidHistory);
          setBids(bidsWithUsernames);
        }
        if (nftData.blockchainData.open_to_offers === true) {
          await fetchBidHistory(nftData.nft_id);
        }
        // console.log(nftData, "nftData");

        nftData.ipfsUrl = await convertIPFSToHTTP(
          nftData.blockchainData.ipfs_url
        );
        const mimeType = await fetchMimeType(
          nftData.blockchainData.ipfs_url,
          nftData
        );
        nftData.nftId = decrypt(nftData.nft_id);

        // Handle image dimensions for images
        if (mimeType.startsWith("image/")) {
          const img = new Image();
          img.onload = () => {
            setDimensions({ width: img.width, height: img.height });
          };
          img.src = nftData.ipfsUrl;
        }

        await fetchFileSize(nftData.ipfsUrl);
        // console.log(nftData.history, nftData.history);
        // let enrichedHistory = [];
        // if (nftData.history.length > 0) {
        //   enrichedHistory = await fetchUsernamesFromHistory(
        //     nftData.history || []
        //   );
        // }
        //console.log(nftData.history, nftData.history);

        setNft({
          ...nftData,
          mimeType,
          history: nftData.history,
        });
        setLoading(false);
        // Handle video autoplay with sound
        if (mimeType.startsWith("video/")) {
          // This timeout ensures the video element is in the DOM
          setTimeout(() => {
            const video = document.getElementById("nft-video");
            if (!video) return;

            // Modern browsers require user interaction to play with sound
            const tryPlay = () => {
              video.muted = false;
              video
                .play()
                .then(() => {
                  // Successfully started playing with sound
                })
                .catch((error) => {
                  // If failed, try with muted first
                  video.muted = true;
                  video.play().then(() => {
                    // Now add a click handler to unmute
                    const unmuteOnClick = () => {
                      video.muted = false;
                      document.removeEventListener("click", unmuteOnClick);
                    };
                    document.addEventListener("click", unmuteOnClick);
                  });
                });
            };

            // First try to play with sound
            tryPlay();

            // Also add click handler for cases where initial play was blocked
            const handleUserInteraction = () => {
              tryPlay();
              document.removeEventListener("click", handleUserInteraction);
            };
            document.addEventListener("click", handleUserInteraction);
          }, 100);
        }
      } catch (err) {
        setError("Failed to fetch NFT details");
        setLoading(false);
      }
    };

    if (nftId) {
      fetchNFTDetail(nftId);
    }
  }, [nftId, render]);
  React.useEffect(() => {
    if (!nft || !nft.blockchainData) return;

    const params = new URLSearchParams(window.location.search);
    const hasOffers = params.has("offers");
    const hasbids = params.has("bids");

    // Use small delay to ensure refs are not null
    setTimeout(() => {
      if (hasOffers && nft.blockchainData.open_to_offers) {
        handleBtnClick(); // Offers
      } else {
        handleBtnClick0(); // Default to Details
      }
    }, 50);
    setTimeout(() => {
      if (hasbids && nft.blockchainData.open_to_auction) {
        handleBtnClick(); // Offers
      } else {
        handleBtnClick0(); // Default to Details
      }
    }, 50);
  }, [nft]);
  const [imgSize, setImgSize] = useState({ width: "auto", height: "auto" });

  useEffect(() => {
    if (nft?.ipfsUrl && nft.mimeType?.startsWith("image/")) {
      const img = new Image();
      img.src = nft.ipfsUrl;

      img.onload = () => {
        const maxWidth = 624;
        let width = img.naturalWidth;
        let height = img.naturalHeight;

        // Scale image to maxWidth while maintaining aspect ratio
        if (width > maxWidth) {
          const scale = maxWidth / width;
          width = maxWidth;
          height = height * scale;
        }

        setImgSize({ width: `${width}px`, height: `${height}px` });
      };
    }
  }, [nft]);

  // ********************* Handle Make Offer Thing Start************************ //
  const SECRET_KEY =
    "0123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef"; // Same key used for encryption
  const ENCRYPTION_ALGORITHM = CryptoJS.AES; // Using AES for encryption

  // Function to decrypt data
  function decrypt(encryptedText) {
    // Split the encrypted text to get IV and encrypted data
    const [ivHex, encryptedData] = encryptedText.split(":");

    // Convert IV and encrypted data from hex to word arrays
    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const encryptedDataBytes = CryptoJS.enc.Hex.parse(encryptedData);

    // Decrypt the data
    const decryptedData = ENCRYPTION_ALGORITHM.decrypt(
      { ciphertext: encryptedDataBytes },
      CryptoJS.enc.Hex.parse(SECRET_KEY),
      { iv: iv }
    );

    // Convert decrypted bytes to UTF-8 string
    return decryptedData.toString(CryptoJS.enc.Utf8);
  }

  // ********************* Handle Make Offer Thing End************************ //
  const handleEndAuction = async (nftId) => {
    setLoading(true); // Optional: show loading spinner

    try {
      await wallet.requestPermissions();
      const userAddress = await wallet.getPKH();

      if (!userAddress) {
        toastRef.current.addToast("Wallet connection failed.", "error");
        setLoading(false);
        return;
      }

      const storedAddress = localStorage.getItem("walletAddress");
      if (!storedAddress || storedAddress !== userAddress) {
        localStorage.setItem("walletAddress", userAddress);
      }

      const tezos = new TezosToolkit(process.env.REACT_APP_RPC_URL);
      tezos.setProvider({ wallet });

      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );

      const decryptedId = decrypt(nftId); // Assuming encrypted, just like in buyNow

      if (!decryptedId || isNaN(decryptedId)) {
        toastRef.current.addToast("Invalid NFT ID.", "error");
        setLoading(false);
        return;
      }

      const bidAmount = parseFloat(nft.currentBid);
      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "0"
      );
      const platformOwner = process.env.REACT_APP_PLATFORM_OWNER;
      const platformFeeMutez = Math.floor(
        bidAmount * (platformFeePercent / 100)
      );
      const op = await contract.methods
        .end_auction(
          decryptedId,
          platformFeeMutez, // Replace with your platform fee logic
          platformOwner
        )
        .send();

      await op.confirmation(1);

      toastRef.current.addToast("Auction ended successfully!", "success");

      setRender((prev) => prev + 1); // Optional: trigger re-render
    } catch (error) {
      //console.error("End Auction Error:", error);

      let errorMessage = "Failed to end auction";
      if (error.message.includes("user rejected")) {
        errorMessage = "Transaction was cancelled";
      } else if (error.message.includes("Not creator")) {
        errorMessage = "Only the creator can end the auction";
      } else if (error.message.includes("Auction not ended")) {
        errorMessage = "Auction is still active";
      }

      toastRef.current.addToast(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };
  const handlePlaceBid = async () => {
    setLoading(true);

    // Validate bid amount
    if (!bidAmount || isNaN(bidAmount) || bidAmount <= 0) {
      toastRef.current.addToast("Please enter a valid bid amount.", "warning");
      setLoading(false);
      return;
    }

    try {
      // Request wallet permissions
      await wallet.requestPermissions();
      const userAddress = await wallet.getPKH();

      if (!userAddress) {
        toastRef.current.addToast("Wallet connection failed.", "error");
        setLoading(false);
        return;
      }
      const storedAddress = localStorage.getItem("walletAddress");
      if (!storedAddress || storedAddress !== userAddress) {
        localStorage.setItem("walletAddress", userAddress);
      }
      // Get contract and decrypt NFT ID
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      const nft_id = decrypt(selectedNFT.nft_id);

      // Convert to mutez (1 ꜩ = 1,000,000 mutez)
      const mutezAmount = Math.floor(Number(bidAmount) * 1_000_000);

      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "2.5"
      );
      const platformFeeMutez = Math.floor(
        bidAmount * (platformFeePercent / 100)
      );
      // Call the bidactn entry point
      const op = await contract.methods
        .bidactn(nft_id, platformFeeMutez)
        .send({ amount: bidAmount });

      socket.emit("new-bid", {
        ownerWallet: selectedNFT.blockchainData.owner,
        bidderWallet: userAddress,
        amount: bidAmount,
        itemName: selectedNFT.blockchainData.name,
        itemId: selectedNFT._id,
      });
      await op.confirmation(1); // wait for 1 block confirmation

      toastRef.current.addToast("Bid placed successfully!", "success");
      setShowBidModal(false);
      setBidAmount("");
      setRender(render + 1); // Refresh data
    } catch (error) {
      //console.error("Error placing bid:", error);

      let errorMessage = "Failed to place bid";
      if (error.message.includes("Auction does not exist")) {
        errorMessage = "Auction not found";
      } else if (error.message.includes("Auction has ended")) {
        errorMessage = "Auction has already ended";
      } else if (error.message.includes("Bid must be higher")) {
        errorMessage = "Your bid must be higher than current highest bid";
      } else if (error.message.includes("user rejected")) {
        errorMessage = "Transaction was cancelled";
      }

      toastRef.current.addToast(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };
  function getCategoryFromMimeType(mimeType) {
    if (!mimeType) return "Art"; // Default to Art if no mime type

    const type = mimeType.split("/")[0]; // Get the first part (image, video, audio, etc)

    switch (type) {
      case "image":
        return "Art";
      case "video":
        return "Video";
      case "audio":
        return "Audio";
      case "application":
        // For PDFs and other documents
        return "Document";
      case "text":
        return "Document";
      case "model":
        // For 3D models
        return "3D Model";
      default:
        return "Art";
    }
  }
  function getIconFromMimeType(mimeType) {
    if (!mimeType) return "image";

    const type = mimeType.split("/")[0];

    switch (type) {
      case "image":
        return "image";
      case "video":
        return "video";
      case "audio":
        return "music";
      case "application":
        return "file";
      case "text":
        return "file-text";
      case "model":
        return "cube";
      default:
        return "image";
    }
  }
  const handleMakeOffer = async () => {
    setLoading(true);

    // Validate offer amount
    if (!bidAmount || isNaN(bidAmount) || bidAmount <= 0) {
      toastRef.current.addToast(
        "Please enter a valid offer amount.",
        "warning"
      );
      setLoading(false);
      return;
    }

    try {
      const userAddress = localStorage.getItem("walletAddress");

      if (!userAddress) {
        toastRef.current.addToast("Wallet connection failed.", "error");
        setLoading(false);
        return;
      }

      localStorage.setItem("userAddress", userAddress);

      // Get contract and decrypt NFT ID
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      const nftId = decrypt(selectedNFT.nft_id);
      const receiverWallet = selectedNFT.blockchainData?.owner;
      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "0"
      );
      const platformOwner = process.env.REACT_APP_PLATFORM_OWNER;
      if (!platformOwner || isNaN(platformFeePercent)) {
        throw new Error("Platform fee or owner is not configured properly.");
      }

      // ✅ Calculate platform fee as amount * (feePercent / 100)
      const platformFee = Math.floor(bidAmount * (platformFeePercent / 100));
      // Send the offer transaction
      let op;
      try {
        op = await contract.methods
          .makeoffer(nftId, userAddress, platformOwner, platformFee)
          .send({ amount: bidAmount });
        const historyData = {
          action: "offer",
          user: userAddress,
          nft_id: nftId,
          details: `${userAddress} made an offer of ${bidAmount} ꜩ on NFT #${nftId}`,
        };
        socket.emit("make-offer", {
          senderWallet: userAddress,
          receiverWallet: receiverWallet,
          nftId: selectedNFT._id,
          nftName: selectedNFT.title || `NFT #${nftId}`,
          offerAmount: bidAmount,
          timestamp: new Date().toISOString(),
        });
        await createHistory(historyData);
      } catch (sendError) {
        //console.error("Transaction send error:", sendError);
        // Check for specific user rejection error (implementation varies by wallet)
        if (sendError.message.includes("user rejected")) {
          toastRef.current.addToast(
            "Transaction was rejected by the user.",
            "error"
          );
        } else {
          toastRef.current.addToast(
            "Failed to send offer transaction.",
            "error"
          );
        }
        setLoading(false);
        return; // Stop after handling send error
      }

      toastRef.current.addToast(
        "Transaction sent! Waiting for confirmation...",
        "info"
      );

      try {
        await op.confirmation(1); // wait for 1 block confirmation
      } catch (confirmationError) {
        //console.error("Transaction confirmation error", confirmationError);
        toastRef.current.addToast("Transaction confirmation failed.", "error");
        setLoading(false);
        return;
      }

      // Success message
      toastRef.current.addToast("Offer placed successfully!", "success");
      setShowBidModal(false);
      setBidAmount("");
      setRender(render + 1);
    } catch (error) {
      // Catch-all for other unexpected errors
      //console.error("Unexpected error placing bid:", error);
      const errorMsg =
        error?.title || error?.message || "An unexpected error occurred.";
      toastRef.current.addToast(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptOffer = async (bidder) => {
    setLoading(true);

    try {
      // await wallet.requestPermissions();
      const userAddress = localStorage.getItem("walletAddress");

      // if (!userAddress) {
      //   toastRef.current.addToast("Wallet connection failed.", "error");
      //   setLoading(false);
      //   return;
      // }

      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      const nftId = decrypt(nft.nft_id); // Decrypt or parseInt if needed
      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "0"
      );
      // Callconst platformFeePercent = parseFloat(process.env.REACT_APP_PLATFORM_FEE || "0");
      const platformOwner = process.env.REACT_APP_PLATFORM_OWNER;

      if (!platformOwner || isNaN(platformFeePercent)) {
        throw new Error("Platform fee or owner is not configured properly.");
      }
      const offer = bids.find((b) => b.bidder === bidder);
      if (!offer) {
        throw new Error("Offer from bidder not found.");
      }
      const offerAmount = parseFloat(offer.amount);
      const platformFee = (offerAmount * platformFeePercent) / 100;
      const op = await contract.methods
        .acptofr(nftId, bidder, platformOwner, platformFee)
        .send();
      // Emit socket notification to bidder
      socket.emit("accept-offer", {
        senderWallet: bidder,
        receiverWallet: userAddress,
        offerAmount: offerAmount,
        nftName: nft.blockchainData.name,
        nftId: nft._id,
      });

      const historyData = {
        action: "sale",
        user: userAddress,
        nft_id: nftId,
        details: `${userAddress} accepted an offer from ${bidder} on NFT #${nftId}`,
      };
      await createHistory(historyData);
      toastRef.current.addToast(
        "Transaction sent! Waiting for confirmation...",
        "info"
      );
      await op.confirmation(1);
      if (
        nft.blockchainData.edition_type === "open" &&
        new Date(nft.blockchainData?.open_until) > new Date()
      ) {
        const editionCount = nft.minted_count + 1;

        const mintOp = await contract.methods
          .mint_next_edition({
            owner: nft.owner,
            base_id: nftId,
            ipfs_url: nft.ipfs_url,
            edition: editionCount,
            open_until: nft.open_until,
          })
          .send();

        await mintOp.confirmation(1);
      }
      // 🎯 Update NFT in MongoDB via API
      const response = await fetch(`${domainpath}/api/art/by-nftid/${nftId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          owner: bidder,
          buyer: bidder,
          sale_status: false,
          open_to_offers: true,
          sale_date: new Date(),
          blockchain_txn_hash: op.opHash,
          $push: { previous_owners: nft.owner },
          $inc: { sales_count: 1 },
        }),
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update art after sale.");
      }

      toastRef.current.addToast("Offer accepted and NFT updated!", "success");

      setBids([]);
      setNft((prev) => ({
        ...prev,
        owner: bidder,
        buyer: bidder,
        sale_status: false,
        open_to_offers: false,
      }));
    } catch (error) {
      //console.error("Error accepting offer:", error);
      toastRef.current.addToast(
        error?.message || "Something went wrong while accepting the offer.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeclineOffer = async (bidder) => {
    setLoading(true);
    try {
      // Request wallet connection
      // await wallet.requestPermissions();
      const userAddress = localStorage.getItem("walletAddress");

      // if (!userAddress) {
      //   toastRef.current.addToast("Wallet connection failed.", "error");
      //   setLoading(false);
      //   return;
      // }

      // Get contract
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );

      // Send transaction
      const decryptedNftId = decrypt(nft.nft_id);
      const nft_id = parseInt(decryptedNftId, 10);

      const params = {
        nft_id: nftId,
        bidder: bidder,
      };

      const op = await contract.methods.decline_offer(nft_id, bidder).send();

      await op.confirmation(1);
      const historyData = {
        action: "decline-offer",
        user: userAddress,
        details: `${userAddress} declined an offer from ${bidder} on NFT #${nft_id}`,
      };
      socket.emit("decline-offer", {
        senderWallet: bidder,
        receiverWallet: userAddress,
        offerAmount: bids.find((b) => b.bidder === bidder)?.amount || 0,
        nftName: nft.blockchainData.name,
        nftId: nft._id,
      });
      await createHistory(historyData);
      toastRef.current.addToast("Offer declined successfully!", "success");

      // Remove declined bid from list
      setBids((prevBids) => prevBids.filter((bid) => bid.nft_id !== nftId));
    } catch (error) {
      //console.error("Decline Offer Error:", error);
      const errorMsg =
        error?.title ||
        error?.message ||
        "Something went wrong while declining the bid.";
      toastRef.current.addToast(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  const openBidModal = async (nft) => {
    if (!userAddress) {
      try {
        // 1. First check if wallet is connected without forcing permissions
        const activeAccount = await wallet.client.getActiveAccount();

        if (!activeAccount) {
          // 2. Only request permissions if no active account exists
          await wallet.requestPermissions({
            forcePermissionRequest: true, // Ensures modal shows
          });
        }

        // 3. Get address after successful connection
        const address = await wallet.getPKH();
        setUserAddress(address);
        localStorage.setItem("walletAddress", address);
        if (nft?.blockchainData.owner === address) {
          toastRef.current.addToast(
            "Oops! You already own this artwork — place a bid isn’t necessary.",
            "error"
          );

          window.location.reload();
        } else {
          setSelectedNFT(nft);
          setShowBidModal(true);
        }
      } catch (error) {
        console.error("Connection error:", error);
        toastRef.current.addToast(
          "Failed to connect wallet. Please try again.",
          "error"
        );
      }
      return;
    } else {
      setSelectedNFT(nft);
      setShowBidModal(true);
    }
  };
  const openMakeofferModal = async (nft) => {
    if (!userAddress) {
      try {
        // 1. First check if wallet is connected without forcing permissions
        const activeAccount = await wallet.client.getActiveAccount();

        if (!activeAccount) {
          // 2. Only request permissions if no active account exists
          await wallet.requestPermissions({
            forcePermissionRequest: true, // Ensures modal shows
          });
        }

        // 3. Get address after successful connection
        const address = await wallet.getPKH();
        setUserAddress(address);
        localStorage.setItem("walletAddress", address);
        if (nft?.blockchainData.owner === address) {
          toastRef.current.addToast(
            "Oops! You already own this artwork — making an offer isn’t necessary.",
            "error"
          );

          // window.location.reload();
        } else {
          setSelectedNFT(nft);
          setshowMakeModal(true);
        }
      } catch (error) {
        console.error("Connection error:", error);
        toastRef.current.addToast(
          "Failed to connect wallet. Please try again.",
          "error"
        );
      }
      return;
    } else {
      setSelectedNFT(nft);
      setshowMakeModal(true);
    }
  };
  const handleBuyNftBtn = async () => {
    setLoading(true);

    try {
      // 1) Request wallet permissions
      await wallet.requestPermissions();
      const userAddress = await wallet.getPKH();

      if (!userAddress) {
        toastRef.current.addToast("Wallet connection failed.", "error");
        setLoading(false);
        return;
      }

      // Store address in localStorage if not already present
      const storedAddress = localStorage.getItem("walletAddress");
      if (!storedAddress || storedAddress !== userAddress) {
        localStorage.setItem("walletAddress", userAddress);
      }

      // 2) Get contract instance
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );

      // 3) Decrypt NFT ID (assuming it's encrypted)
      const nftId = decrypt(nft.nft_id);

      if (!nftId || isNaN(nftId)) {
        toastRef.current.addToast("Invalid NFT ID.", "error");
        setLoading(false);
        return;
      }

      // 4) Get platform fee and owner from env
      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "2.5" // Default to 2.5% if not set
      );
      const platformOwner = process.env.REACT_APP_PLATFORM_OWNER;

      if (!platformOwner) {
        toastRef.current.addToast("Platform owner not configured.", "error");
        setLoading(false);
        return;
      }

      // 5) Calculate amounts (convert from mutez to tez)
      const nftPriceTez = toTez(nft.blockchain_metadata.price);
      const platformFeeTez = nftPriceTez * (platformFeePercent / 100);
      const totalAmountTez = nftPriceTez + platformFeeTez;

      // Convert back to mutez for the contract call
      const platformFeeMutez = Math.floor(platformFeeTez * 1000000);

      // 6) Call the contract with properly formatted parameters
      const op = await contract.methods
        .buynft(
          parseInt(nftId), // Ensure nft_id is a number
          platformOwner, // platform_owner address
          platformFeeMutez // platform_fee in mutez
        )
        .send({
          amount: totalAmountTez,
          mutez: false, // amount is in tez
        });

      // 7) Wait for confirmation
      await op.confirmation(1);
      socket.emit("successful-purchase", {
        buyerWallet: userAddress,
        sellerWallet: nft.blockchainData.owner,
        price: nftPriceTez,
        itemName: nft.blockchainData.name,
        itemId: nft._id,
      });
      // 8) Create history record
      const historyData = {
        action: "buy",
        user: userAddress,
        nft_id: nftId,
        details: `${userAddress} purchased NFT #${nftId} for ${nftPriceTez} ꜩ`,
      };
      await createHistory(historyData);

      // 9) Success!
      toastRef.current.addToast("Purchase completed successfully!", "success");
      setRender((prev) => prev + 1); // Refresh the UI
    } catch (error) {
      console.error("Buy Now Error:", error);

      let errorMessage = "Failed to complete purchase";
      if (error.message.includes("user rejected")) {
        errorMessage = "Transaction was cancelled";
      } else if (error.message.includes("NFT does not exist")) {
        errorMessage = "NFT no longer exists";
      } else if (error.message.includes("not for sale")) {
        errorMessage = "NFT is no longer for sale";
      } else if (error.message.includes("Insufficient funds")) {
        errorMessage = "Insufficient funds for purchase";
      } else if (error.message.includes("Invalid contract parameter")) {
        errorMessage = "Invalid transaction parameters";
      }

      toastRef.current.addToast(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <GlobalStyles />
      <section className="container " id="nft-item-details">
        {loading ? (
          <div className="w-full h-[300px] bg-gray-300 animate-pulse rounded"></div>
        ) : (
          <>
            <div className="flex flex-col lg:flex-row  ">
              {/* Left Column - Fixed Media */}
              <div className="w-full lg:w-1/2 lg:fixed lg:top-4 lg:left-0 lg:h-screen flex items-center justify-end p-4 ">
                <div
                  className={
                    nft?.mimeType?.startsWith("audio/")
                      ? "relative w-full h-full max-w-2xl flex items-center justify-center musicbng"
                      : "relative w-full h-full max-w-2xl flex items-center justify-center "
                  }
                >
                  {nft?.ipfsUrl ? (
                    nft?.mimeType?.startsWith("image/") ? (
                      <img
                        src={nft.ipfsUrl}
                        className="max-h-[80vh] w-auto object-contain "
                        alt={nft.title}
                      />
                    ) : nft.mimeType?.startsWith("video/") ? (
                      <video
                        controls
                        autoPlay
                        loop
                        className="max-h-[80vh] w-auto object-contain "
                      >
                        <source src={nft.ipfsUrl} type={nft.mimeType} />
                      </video>
                    ) : (
                      <div className="w-full max-w-md p-8  ">
                        <audio src={nft.ipfsUrl} controls className="w-full" />
                      </div>
                    )
                  ) : (
                    <div className="text-gray-400">No media available</div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-1/2 lg:ml-auto p-6">
                <div className="item_info">
                  {nft?.auctionDetails?.end_time &&
                  new Date(nft.auctionDetails.end_time) > new Date() ? (
                    <div className="de_countdown">
                      Auctions ends in:{" "}
                      <Clock
                        deadline={formatDate(
                          new Date(nft.auctionDetails.end_time)
                        )}
                      />
                    </div>
                  ) : null}
                  <h2>
                    {nft?.title} {" #" + nft?.nftId}
                  </h2>
                  <div className="item_info_counts">
                    <div className="item_info_type">
                      <i
                        className={`fa fa-${getIconFromMimeType(
                          nft?.mime_type
                        )}`}
                      ></i>
                      {getCategoryFromMimeType(nft?.mime_type) || "Art"}
                    </div>
                    <div className="item_info_views">
                      <i className="fa fa-eye"></i>
                      {nft?.views || 0}
                    </div>
                    <div className="item_info_like">
                      <i className="fa fa-heart"></i>
                      {nft?.likes || 0}
                    </div>
                  </div>
                  <p className="py-2">{nft?.description}</p>

                  <div className="d-flex flex-row flex ">
                    <div className="mr-10">
                      <h6>Creator</h6>
                      <div className="item_author">
                        <div className="author_list_pp ">
                          <span>
                            <img
                              className="lazy"
                              src={
                                nft?.creatorProfile?.profileImage ||
                                generateAvatar(nft?.blockchainData?.creator) ||
                                "./img/author/author-1.jpg"
                              }
                              alt=""
                            />
                            <i className="fa fa-check"></i>
                          </span>
                        </div>
                        <div className="author_list_info">
                          <span>
                            {nft?.creatorProfile?.username ||
                              shortenAddress(
                                nft?.creatorProfile?.walletAddress
                              )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style={{ backgroundSize: "cover" }}>
                      <h6>Collection</h6>
                      <div
                        className="item_author"
                        style={{ backgroundSize: "cover" }}
                      >
                        <div
                          className="author_list_pp"
                          style={{ backgroundSize: "cover" }}
                        >
                          <a href="04_retro-collection.html">
                            <img
                              className="lazy"
                              src={
                                nft?.ownerProfile?.profileImage ||
                                generateAvatar(nft?.blockchainData?.owner) ||
                                "./img/author/author-1.jpg"
                              }
                              alt=""
                            />
                            <i className="fa fa-check"></i>
                          </a>
                        </div>
                        <div
                          className="author_list_info"
                          style={{ backgroundSize: "cover" }}
                        >
                          <a href="04_retro-collection.html">
                            {" "}
                            {nft?.ownerProfile?.username ||
                              shortenAddress(nft?.ownerProfile?.walletAddress)}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="spacer-40"></div>

                  <div className="de_tab mt-4">
                    <ul className="de_nav">
                      <li ref={mainBtnRef0} className="active">
                        <span onClick={handleBtnClick0}>Details</span>
                      </li>
                      {/* {nft?.open_to_offers === true && creatorSales >= 10 ? ( */}
                      {nft?.blockchainData.open_to_offers === true ? (
                        <li ref={mainBtnRef}>
                          <span onClick={handleBtnClick}>Offers</span>
                        </li>
                      ) : (
                        ""
                      )}

                      {nft?.blockchainData.open_to_auction === true ? (
                        <li ref={mainBtnRef}>
                          <span onClick={handleBtnClick}>Bids</span>
                        </li>
                      ) : (
                        ""
                      )}
                      <li ref={mainBtnRef1} className="">
                        <span onClick={handleBtnClick1}>History</span>
                      </li>
                    </ul>

                    <div className="de_tab_content">
                      {openMenu && (
                        <div className="tab-1 onStep fadeIn">
                          {bids.length > 0 ? (
                            bids.map((bid, index) => (
                              <div className="p_list" key={index}>
                                <div className="p_list_pp">
                                  <span>
                                    <img
                                      className="lazy"
                                      src={
                                        bid.profileImage
                                          ? `${bid.profileImage}`
                                          : generateAvatar(bid.bidder)
                                      }
                                      alt=""
                                    />
                                    <i className="fa fa-check"></i>
                                  </span>
                                </div>
                                <div className="p_list_info ">
                                  Bid{" "}
                                  {/* {bid.author.id === nft.author.id && "accepted"}{" "} */}
                                  <b>{toTez(bid.amount)} ꜩ</b>
                                  <span className="flex items-center justify-between bidslist_info">
                                    <div>
                                      by{" "}
                                      <b>
                                        {bid.username &&
                                        bid.username !== bid.bidder
                                          ? bid.username
                                          : shortenAddress(bid.bidder)}
                                      </b>
                                      <button
                                        onClick={() =>
                                          navigator.clipboard.writeText(
                                            bid.bidder
                                          )
                                        }
                                        //className="opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                        title="Copy Wallet Address"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M10 1H2a1 1 0 0 0-1 1v11h1V2h8V1z" />
                                          <path d="M13 3H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm0 1v11H5V4h8z" />
                                        </svg>
                                      </button>
                                      at{" "}
                                      {moment().diff(
                                        moment(bid.timestamp),
                                        "hours"
                                      ) < 24
                                        ? moment(bid.timestamp).fromNow()
                                        : moment(bid.timestamp).format(
                                            "DD MMMM YYYY"
                                          )}
                                    </div>

                                    {bidderOwner === userAddress &&
                                      nft?.blockchainData?.open_to_offers &&
                                      bid?.bidder !== userAddress && (
                                        <div className="flex items-center justify-between">
                                          <div className="relative group mr-2">
                                            <button
                                              title="Accept Offer"
                                              onClick={() =>
                                                handleAcceptOffer(bid.bidder)
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                                fill="green"
                                                width="20"
                                                height="20"
                                              >
                                                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                                              </svg>
                                            </button>
                                          </div>
                                          <div className="relative group">
                                            <button
                                              title="Decline Offer"
                                              onClick={() =>
                                                handleDeclineOffer(bid.bidder)
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                                fill="red"
                                                width="20"
                                                height="20"
                                              >
                                                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>No offers yet.</p>
                          )}
                          <div className="spacer-40"></div>
                        </div>
                      )}
                      {openMenu0 && (
                        <div className="tab-1 onStep fadeIn">
                          <div className="d-block mb-3">
                            <div className="mr40">
                              <div className="mb-12">
                                <h6>Owner</h6>
                                <div className="item_author">
                                  <div className="author_list_pp">
                                    <span>
                                      <img
                                        className="lazy"
                                        src={
                                          nft?.ownerProfile?.profileImage ||
                                          generateAvatar(
                                            nft?.blockchainData?.owner
                                          ) ||
                                          "./img/author/author-1.jpg"
                                        }
                                        alt=""
                                      />
                                      <i className="fa fa-check"></i>
                                    </span>
                                  </div>
                                  <div className="author_list_info">
                                    <span>
                                      {nft?.ownerProfile?.username ||
                                        shortenAddress(
                                          nft?.ownerProfile?.walletAddress
                                        )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h6>Properties</h6>
                            <div className="row ">
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Background</h5>
                                  <h4>Yellowish Sky</h4>
                                  <span>85% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Eyes</h5>
                                  <h4>Purple Eyes</h4>
                                  <span>14% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Nose</h5>
                                  <h4>Small Nose</h4>
                                  <span>45% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Mouth</h5>
                                  <h4>Smile Red Lip</h4>
                                  <span>61% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Neck</h5>
                                  <h4>Pink Ribbon</h4>
                                  <span>27% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Hair</h5>
                                  <h4>Pink Short</h4>
                                  <span>35% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Accessories</h5>
                                  <h4>Heart Necklace</h4>
                                  <span>33% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Hat</h5>
                                  <h4>Cute Panda</h4>
                                  <span>62% have this trait</span>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="nft_attr">
                                  <h5>Clothes</h5>
                                  <h4>Casual Purple</h4>
                                  <span>78% have this trait</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {openMenu1 && (
                        <div className="tab-2 onStep fadeIn">
                          {nft?.history?.map((entry, index) => (
                            <div
                              className="p_list h-16 flex items-center"
                              key={index}
                            >
                              <div className="p_list_pp">
                                <span>
                                  <img
                                    className="lazy"
                                    src={
                                      entry.author?.avatar
                                        ? entry.author.avatar
                                        : generateAvatar(entry.user)
                                    }
                                    alt=""
                                  />
                                  <i className="fa fa-check"></i>
                                </span>
                              </div>
                              <div className="p_list_info">
                                {entry.action === "offer" && (
                                  <span>
                                    Bid <b>{entry.value} ꜩ</b>
                                  </span>
                                )}
                                {entry.action === "like" && (
                                  <span>liked this</span>
                                )}
                                {entry.action === "follow" && (
                                  <span>followed</span>
                                )}
                                {entry.action === "sale" && (
                                  <span>
                                    bought for <b>{entry.value} ꜩ</b>
                                  </span>
                                )}
                                {entry.action === "mint" && <span>minted</span>}
                                {/* Add more conditions as needed */}

                                <span>
                                  by{" "}
                                  <b>
                                    {entry.author?.username
                                      ? entry.author.username
                                      : shortenAddress(entry.user)}
                                  </b>{" "}
                                  at {moment(entry.timestamp).format("L, LT")}
                                </span>
                              </div>
                            </div>
                          ))}

                          <div className="spacer-40"></div>
                        </div>
                      )}

                      {nft?.blockchainData?.open_to_sell === true &&
                      nft?.blockchainData.price !== 0 ? (
                        <>
                          <div className="spacer-40"></div>
                          <h6>Price</h6>
                          <div
                            className="nft-item-price"
                            style={{ backgroundSize: "cover" }}
                          >
                            <img src="images/misc/ethereum.svg" alt="" />
                            <span>{nft?.blockchainData.price}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="d-flex flex-row mt-2">
                        {nft?.blockchainData?.owner !== userAddress &&
                        nft?.blockchainData.price &&
                        nft?.blockchainData?.open_to_sell === true ? (
                          <button
                            className="btn-main lead mb-5 mr15"
                            onClick={(e) => handleBuyNftBtn()}
                          >
                            Buy Now
                          </button>
                        ) : (
                          ""
                        )}
                        {nft?.blockchainData?.open_to_offers === true &&
                        nft?.blockchainData.owner !== userAddress ? (
                          <button
                            className="btn-clear lead mb-5 mr-1"
                            onClick={() => openMakeofferModal(nft)}
                          >
                            Make an Offer
                          </button>
                        ) : (
                          ""
                        )}
                        {nft?.blockchainData?.open_to_auction === true &&
                        nft?.blockchainData.owner === userAddress ? (
                          <button
                            className="btn-clear lead mb-5 mr-1"
                            onClick={(e) => handleEndAuction(nft.nft_id)}
                          >
                            End An auction
                          </button>
                        ) : null}
                        {/* {console.log(nft, "nft")} */}
                        {nft?.blockchainData?.open_to_auction === true &&
                        nft?.blockchainData.owner !== userAddress ? (
                          <button
                            className="btn-main btn-lg btn-light"
                            onClick={(e) => openBidModal(nft)}
                          >
                            Place Bid
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
      {/* <Footer /> */}

      {showMakeModal && (
        <div className="bid-modal">
          <div className="bid-modal-content relative">
            <button
              onClick={() => setshowMakeModal(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
            >
              ✖
            </button>
            <h3>Make Your Offer</h3>
            {/* <p>Current Price: {selectedNFT.price} ꜩ</p> */}
            <div className="bid-modal-inputdiv">
              <input
                type="number"
                value={bidAmount}
                min={0.1}
                onChange={(e) =>
                  handleBidChange(e, toTez(selectedNFT.currentBid))
                }
                placeholder="Enter Offer amount 1 ꜩ or 2.05 ꜩ"
              />
            </div>
            {bidError && selectedNFT.currentBid && (
              <p className="text-red-500 text-sm mt-1 mb-2">
                Offer amount must be higher than the current offer of{" "}
                {toTez(selectedNFT.currentBid)} ꜩ
              </p>
            )}
            <div className="bid-modal-btnmaindiv">
              <button
                className="btn-main"
                onClick={handleMakeOffer}
                disabled={!bidAmount || bidError}
              >
                Submit
              </button>
              <button
                className="btn-clear"
                onClick={() => {
                  setshowMakeModal(false);
                  setBidError(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showBidModal && (
        <div className="bid-modal">
          <div className="bid-modal-content relative">
            <button
              onClick={(e) => setShowBidModal(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
            >
              ✖
            </button>
            {/* {console.log(selectedNFT)} */}

            <h3>Place Your Bid</h3>

            {selectedNFT.auctionDetails && (
              <div className="auction-info mb-4">
                <p className="text-sm mb-1">
                  <strong>Auction ends:</strong>{" "}
                  {/* {formatDate(selectedNFT.auctionDetails.end_time)} */}
                  {new Date(selectedNFT.auctionDetails.end_time).toLocaleString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true, // set to false for 24h format
                    }
                  )}
                </p>
                {new Date(selectedNFT.auctionDetails.end_time) > new Date() && (
                  <div className="flex flex-col items-center bg-white px-4 py-2 rounded-xl border border-dashed border-indigo-200 shadow-inner">
                    <span className="text-xs font-semibold text-indigo-600 uppercase mb-1">
                      Time Remaining
                    </span>
                    <div className="text-xl font-mono font-bold text-indigo-800 tracking-widest">
                      <Clock deadline={selectedNFT.auctionDetails.end_time} />
                    </div>
                  </div>
                )}
                {selectedNFT.auctionDetails.highest_bid > 0 ? (
                  <p className="text-sm">
                    <strong>Last Bid:</strong>{" "}
                    {toTez(selectedNFT.auctionDetails.highest_bid)} ꜩ
                  </p>
                ) : (
                  <p className="text-sm">No bids yet</p>
                )}
              </div>
            )}

            <div className="bid-modal-inputdiv">
              <input
                type="number"
                value={bidAmount}
                min={
                  selectedNFT.auctionDetails?.highest_bid
                    ? toTez(selectedNFT.auctionDetails.highest_bid) + 1
                    : 0.1
                }
                step="0.1"
                onChange={(e) => {
                  const value = e.target.value;
                  setBidAmount(value);

                  // Validate bid is higher than current
                  const currentBid = selectedNFT.auctionDetails?.highest_bid
                    ? toTez(selectedNFT.auctionDetails.highest_bid)
                    : 0;
                  setBidError(parseFloat(value) <= currentBid);
                }}
                placeholder={
                  selectedNFT.auctionDetails?.highest_bid
                    ? `Enter bid (min ${(
                        toTez(selectedNFT.auctionDetails.highest_bid) + 0.1
                      ).toFixed(1)} ꜩ)`
                    : "Enter bid (min 0.1 ꜩ)"
                }
              />
            </div>

            {bidError && (
              <p className="text-red-500 text-sm mt-1 mb-2 text-left">
                Bid must be higher than current highest bid
              </p>
            )}

            <div className="bid-modal-btnmaindiv">
              <button
                type="btn"
                className="btn-main"
                onClick={handlePlaceBid}
                disabled={!bidAmount || bidError}
              >
                Submit
              </button>
              <button
                type="btn"
                className="btn-clear"
                onClick={(e) => setShowBidModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <CustomToastContainer ref={toastRef} />
      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
      <ArtViewTracker artId={nftId} />
    </div>
  );
};

export default memo(ItemDetailRedux);
